module.exports = __webpack_public_path__ + "img/tema-3-3.bdeb165c.svg";